import { pipe, tap } from 'rxjs';

export const preventDefault = <T extends MouseEvent>() => pipe(tap((evt: T) => evt.preventDefault()));
